// extracted by mini-css-extract-plugin
module.exports = {"Bodylinear":"ProgressBar_Bodylinear__3WVR8","modelName":"ProgressBar_modelName__2mn5I","colorLiner":"ProgressBar_colorLiner__1ba_j"};